import RecipeComposerModal from "./RecipeComposerModal";

export default function AddRecipePopup({ isOpen, onClose, onSaved }) {
  return (
    <RecipeComposerModal
      isOpen={isOpen}
      mode="create"
      onClose={onClose}
      onSaved={onSaved}
    />
  );
}
